import { Route } from "react-router-dom";
import Exam from "../pages/exam/exam";
import Instructions from "../pages/exam/instructions";
import Results from "../pages/exam/results";
import HomeLayout from "../themes/Home/HomeLayout";
import PrivateRoute from "./PrivateRoute";

const ExamRoutes = () => {
  return (
    <Route
      path="/exam/*"
      element={
        <PrivateRoute>
          <HomeLayout />
        </PrivateRoute>
      }
    >
      <Route path="instructions" element={<Instructions />} />
      <Route path="exam" element={<Exam />} />
      <Route path="results" element={<Results />} />
    </Route>
  );
};

export default ExamRoutes;
